export default "__VITE_ASSET__c7d7f79c__"